import { createFileRoute } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { PracticeDetailsPage, practiceDetailsBeforeLoad } from '@/pages/settings/practice-details';

export const Route = createFileRoute('/settings/practice-details')({
    beforeLoad: practiceDetailsBeforeLoad,
    component: PracticeDetailsPage,
    pendingComponent: LoadingPage,
});
